module.exports = __webpack_public_path__ + "static/media/photo301.2b01e775.jpg";